export enum ReelElementName {
  BAR3 = '3xBAR',
  BAR2 = '2xBAR',
  BAR = 'BAR',
  SEVEN = '7',
  CHERRY = 'CHERRY',
}